import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "startIcon", "endIcon", "badge", "color", "active", "buttonType", "sideBarType", "size", "loading", "disabled"];
import React from 'react';
import PT from 'prop-types';
import SpinnerIcon from '@scaleflex/icons/spinner';
import TwoArrowsRight from '@scaleflex/icons/two-arrows-right';
import TwoArrowsLeft from '@scaleflex/icons/two-arrows-left';
import { intrinsicComponent, objectValues } from '../../utils/functions';
import Badge from '../badge';
import { ButtonSize, ButtonColor } from '../../utils/types';
import { ButtonType, SideBar } from './types';
import { getIconSize, getSideBarIconSize } from './button.utils';
import Styled from './button.styles';
var Button = intrinsicComponent(function (_ref, ref) {
  var children = _ref.children,
    startIcon = _ref.startIcon,
    endIcon = _ref.endIcon,
    badge = _ref.badge,
    color = _ref.color,
    active = _ref.active,
    buttonType = _ref.buttonType,
    _ref$sideBarType = _ref.sideBarType,
    sideBarType = _ref$sideBarType === void 0 ? SideBar.Left : _ref$sideBarType,
    size = _ref.size,
    loading = _ref.loading,
    disabled = _ref.disabled,
    rest = _objectWithoutProperties(_ref, _excluded);
  var getSideBarArrows = function getSideBarArrows(props) {
    switch (sideBarType) {
      case SideBar.Right:
        return active ? /*#__PURE__*/React.createElement(TwoArrowsLeft, props) : /*#__PURE__*/React.createElement(TwoArrowsRight, props);
      case SideBar.Left:
        return active ? /*#__PURE__*/React.createElement(TwoArrowsRight, props) : /*#__PURE__*/React.createElement(TwoArrowsLeft, props);
      default:
    }
  };
  var getSideBarSection = function getSideBarSection() {
    var sideBarSection = [/*#__PURE__*/React.createElement(Styled.SideArrows, {
      key: "arrows",
      sideBarType: sideBarType
    }, getSideBarArrows({
      size: getSideBarIconSize(size)
    }))];
    var divider = /*#__PURE__*/React.createElement(Styled.Divider, {
      key: "divider",
      size: size,
      sideBarType: sideBarType
    });
    if (sideBarType === SideBar.Right) {
      sideBarSection.unshift(divider);
    } else {
      sideBarSection.push(divider);
    }
    return buttonType === ButtonType.Sidebar && sideBarSection;
  };
  return /*#__PURE__*/React.createElement(Styled.Button, _extends({
    type: "button",
    buttonType: buttonType
  }, rest, {
    disabled: loading || disabled,
    sideBarType: sideBarType,
    color: color,
    active: active,
    size: size,
    ref: ref
  }), sideBarType === SideBar.Left && getSideBarSection(), /*#__PURE__*/React.createElement(Styled.Wrapper, null, startIcon && /*#__PURE__*/React.createElement(Styled.StartIcon, {
    $loading: loading,
    size: size
  }, typeof startIcon === 'function' ? loading ? /*#__PURE__*/React.createElement(SpinnerIcon, {
    size: getIconSize(size)
  }) : startIcon({
    size: getIconSize(size)
  }) :
  // eslint-disable-next-line unicorn/no-nested-ternary
  loading ? /*#__PURE__*/React.createElement(SpinnerIcon, {
    size: getIconSize(size)
  }) : startIcon), loading && !startIcon && /*#__PURE__*/React.createElement(Styled.StartIcon, {
    $loading: loading
  }, /*#__PURE__*/React.createElement(SpinnerIcon, {
    size: getIconSize(size)
  })), /*#__PURE__*/React.createElement(Styled.Label, null, children), endIcon && /*#__PURE__*/React.createElement(Styled.EndIcon, null, typeof endIcon === 'function' ? endIcon({
    size: getIconSize(size)
  }) : endIcon)), sideBarType === SideBar.Right && getSideBarSection(), badge && /*#__PURE__*/React.createElement(Styled.Badge, null, /*#__PURE__*/React.createElement(Badge, {
    inline: true,
    size: 14,
    padding: "0 1px",
    badgeContent: badge,
    color: color === ButtonColor.Primary ? 'white' : 'secondary'
  })));
});
Button.defaultProps = {
  size: ButtonSize.Md,
  color: ButtonColor.Secondary,
  buttonType: ButtonType.Default,
  active: false
};
Button.propTypes = {
  size: PT.oneOf(objectValues(ButtonSize)),
  color: PT.oneOf(objectValues(ButtonColor)),
  buttonType: PT.oneOf(objectValues(ButtonType)),
  sideBarType: PT.oneOf(objectValues(SideBar)),
  startIcon: PT.oneOfType([PT.node, PT.func]),
  endIcon: PT.oneOfType([PT.node, PT.func]),
  badge: PT.node,
  active: PT.bool,
  loading: PT.bool,
  disabled: PT.bool
};
export default Button;